import { useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import Variables from '../../style/variables.scss';
import Modal from '../04_ modal/Modal';

type Language = 'en' | 'hr';

const content: Record<
  Language,
  { title: string; heading: string; paragraphs: string[] }
> = {
  en: {
    title: 'Written Consumer Complaint',
    heading: 'NOTICE ON HOW TO SUBMIT A WRITTEN GUEST/CONSUMER COMPLAINT',
    paragraphs: [
      'Based on Article 10. paragraph 10. of the Act on Catering Activities ("Narodne Novine" No. 85/15, 121/16, 99/18, 25/19, 98/19, 32/20, 42/20, 126/21), and in connection with Article 10. of the Act on Consumer Protection ("Narodne Novine" No. 19/22, 59/23, 59/26), we inform guests/consumers that they can submit a written complaint about the quality of our products or services at the business premises, by mail to the address of the headquarters: Cornaro hotel, Sinjska 6, 21000 Split or at e-mail: info@cornarohotel.com',
      'We will confirm receipt of the complaint in writing without delay via mail or email and respond to the complaint in writing within 15 days from the day of receipt of the complaint in accordance with the notification on how to submit a written complaint on business premises. Please provide your name, surname, and address with the complaint so that we can send you a written response to your complaint and thus influence the improvement of quality and your satisfaction. Prices are quoted in Euros. Payment is only possible in Euros.',
      'If you do not receive a receipt, you are not required to pay. Guests under 18 years of age may not be served or consume alcohol. VAT is included in the price. We will be happy to answer the inquiries of guests who want to know more about the ingredients of certain dishes. Please let us know about allergies or special dietary requirements that we should take into account when preparing the dishes you ordered. Bringing and consuming food and beverage from outside hotel is prohibited. Wine corkage fee is 20 euro per bottle.',
    ],
  },
  hr: {
    title: 'Pisani prigovor potrošača',
    heading: 'OBAVIJEST O NAČINU PODNOŠENJA PISANOG PRIGOVORA GOSTA/POTROŠAČA',
    paragraphs: [
      'Temeljem čl.10. st.10. Zakona o ugostiteljskoj djelatnosti („Narodne novine“ br. 85/15, 121/16, 99/18, 25/19, 98/19, 32/20, 42/20, 126/21), a u vezi sa čl.10. Zakona o zaštiti potrošača („Narodne novine“ br. 19/22, 59/23, 59/26) obavještavamo goste/potrošače da pisani prigovor na kvalitetu naših proizvoda ili usluga mogu podnijeti u poslovnim prostorijama, putem pošte na adresu sjedišta: Cornaro hotel, Sinjska 6, 21000 Split ili na e-mail: info@cornarohotel.com',
      'U pisanom obliku bez odgađanja putem pošte ili elektroničke pošte ćemo potvrditi zaprimanje prigovora te u pisanom obliku odgovoriti na prigovor u roku od 15 dana od dana zaprimanja prigovora sukladno obavijesti o načinu podnošenja pisanog prigovora u poslovnim prostorijama. Molimo uz prigovor dostavite vaše ime, prezime i adresu kako bismo vam mogli uputiti pismeni odgovor na vaš prigovor te tako utjecati na poboljšanje kvalitete i vaše zadovoljstvo. Cijene su izražene u eurima. Plaćanje je moguće samo u eurima.',
      'Ako niste dobili račun niste dužni platiti. Zabranjeno posluživanje i konzumacija alkohola mlađima od 18. PDV je uključen u cijenu. Rado ćemo odgovoriti na upite gostiju koji žele znati više o sastojcima određenih jela. Obavijestite nas o alergijama ili posebnim prehrambenim zahtjevima koje bismo trebali uzeti u obzir prilikom pripreme jela koja ste naručili. Unošenje i konzumiranje hrane i pića donesene izvan hotela je zabranjeno. Naknada za otvaranje donesene boce vina iznosi 20 eura po boci.',
    ],
  },
};

const ConsumerComplaintModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
}) => {
  const [language, setLanguage] = useState<Language>('en');
  const { title, heading, paragraphs } = content[language];

  return (
    <Modal
      id='consumer_complaint_modal'
      isOpen={isOpen}
      onClose={onClose}
      primaryColor={Variables.primaryColor}
      secondaryColor={Variables.secondaryColor}
    >
      <div className='consumer_complaint_modal'>
        <div className='consumer_complaint_modal_content'>
          <h2>{title}</h2>
          <div className='consumer_complaint_modal_languages'>
            <div
              className={`opacity_transition_low${
                language === 'en' ? ' active' : ''
              }`}
              onClick={() => setLanguage('en')}
            >
              ENGLISH
            </div>
            <div
              className={`opacity_transition_low${
                language === 'hr' ? ' active' : ''
              }`}
              onClick={() => setLanguage('hr')}
            >
              HRVATSKI
            </div>
          </div>
          <h3>{heading}</h3>
          {paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ConsumerComplaintModal;
